

// import React, { useState } from "react";
// import { TextField, Button, Box, Typography, Stepper, Step, StepLabel } from "@mui/material";
// import { useNavigate } from 'react-router-dom';
// import { createBank } from "../../services/apiService";

// const steps = ["البيانات العامة", "الفروع", "الطاولات", "الخزن", "المطابخ"];

// const StorageSetup = () => {
//   const navigate = useNavigate();
  

//   const [formData, setFormData] = useState({
//     name: "الخزنة الرئيسية",
//     discount_percentage: "0",
//   });

//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState("");

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "discount_percentage") {
//       if (value === "" || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
//         setFormData({ ...formData, [name]: value });
//       }
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const handleSave = async () => {
//     try {
//       if (!formData.name) {
//         throw new Error("❌ اسم البنك مطلوب لإتمام العملية.");
//       }

//       const response = await createBank(formData.name, formData.discount_percentage);
//       setSuccessMessage("تم حفظ البيانات بنجاح!");
//       setError(null);

//       setTimeout(() => navigate('/setup/kitchens'), 0);
//     } catch (err) {
//       setError(err.message);
//       setSuccessMessage("");
//     }
//   };

//   return (
//     <Box sx={{ maxWidth: 600, mx: "auto", mt: 5, p: 4, boxShadow: 3, borderRadius: 2 }}>
//       <Stepper activeStep={3} alternativeLabel sx={{ mb: 4 }}>
//         {steps.map((label) => (
//           <Step key={label}>
//             <StepLabel>{label}</StepLabel>
//           </Step>
//         ))}
//       </Stepper>

//       <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
//         إعداد الخزن والبنوك
//       </Typography>

//       <TextField
//         label="اسم الخزنة \ البنك"
//         name="name"
//         fullWidth
//         value={formData.name}
//         onChange={handleChange}
//         sx={{ mb: 2 }}
//       />

//       <TextField
//         label="نسبة الخصم (%)"
//         name="discount_percentage"
//         type="number"
//         value={formData.discount_percentage}
//         onChange={handleChange}
//         fullWidth
//         sx={{ mb: 2 }}
//         inputProps={{ min: 0, max: 100 }}
//       />

//       <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
//         <Button variant="contained" color="primary" onClick={handleSave}>
//           التالي
//         </Button>
//       </Box>

//       {successMessage && (
//         <Typography color="success.main" sx={{ mt: 2 }}>
//           {successMessage}
//         </Typography>
//       )}

//       {error && (
//         <Typography color="error" sx={{ mt: 2 }}>
//           {error}
//         </Typography>
//       )}
//     </Box>
//   );
// };

// export default StorageSetup;



// تنسيق
import React, { useState } from "react";
import { 
  TextField, Button, Box, Typography, Stepper, Step, StepLabel, 
  Paper, useMediaQuery, useTheme, CircularProgress, Alert
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { createBank } from "../../services/apiService";

const steps = ["البيانات العامة", "الفروع", "الطاولات", "الخزن", "المطابخ"];

const StorageSetup = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // ✅ دعم الهواتف المحمولة
  const isTablet = useMediaQuery(theme.breakpoints.down("md")); // ✅ دعم الأجهزة اللوحية

  const [formData, setFormData] = useState({
    name: "الخزنة الرئيسية",
    discount_percentage: "0",
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "discount_percentage") {
      if (value === "" || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSave = async () => {
    try {
      if (!formData.name) {
        throw new Error("❌ اسم البنك مطلوب لإتمام العملية.");
      }

      setLoading(true);
      await createBank(formData.name, formData.discount_percentage);
      setSuccessMessage("✅ تم حفظ البيانات بنجاح!");
      setError(null);

      setTimeout(() => navigate('/setup/kitchens'), 2500);
    } catch (err) {
      setError(err.message);
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 5, mb: 5 }}>
      <Paper elevation={4} sx={{ maxWidth: 600, width: "100%", p: 4, borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}>
        
        {/* ✅ تحسين `Stepper` ليكون متجاوبًا */}
        <Stepper activeStep={3} alternativeLabel={!isSmallScreen} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{!isTablet ? label : null}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Typography variant={isSmallScreen ? "h6" : "h5"} sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}>
          إعداد الخزن والبنوك
        </Typography>

        {/* ✅ إدخال اسم البنك */}
        <TextField
          label="اسم الخزنة \ البنك"
          name="name"
          fullWidth
          value={formData.name}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        {/* ✅ نسبة الخصم (تحقق من القيم) */}
        <TextField
          label="نسبة الخصم (%)"
          name="discount_percentage"
          type="number"
          value={formData.discount_percentage}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
          inputProps={{ min: 0, max: 100 }}
        />

        {/* ✅ تحسين ترتيب الأزرار لتكون متجاوبة */}
        <Box sx={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", gap: 2, justifyContent: "center", mt: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSave} 
            disabled={loading} 
            fullWidth={isSmallScreen}
          >
            {loading ? <CircularProgress size={20} /> : "التالي"}
          </Button>
        </Box>

        {/* ✅ تحسين رسائل التنبيه */}
        {successMessage && (
          <Alert severity="success" sx={{ mt: 2, textAlign: "center" }}>
            {successMessage}
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2, textAlign: "center" }}>
            ❌ {error}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default StorageSetup;
